module.exports = __webpack_public_path__ + "sgby/img/cloud-inside.2db2a11.png";